import React, { useEffect, useState } from "react";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import "@reach/combobox/styles.css";

const InfoVerifiedDropDown = ({ fun, currentValue }) => {
  // useEffect(() => {
  //   setinputVal(currentValue);
  // }, [currentValue]);

  const [inputVal, setinputVal] = useState(currentValue);

  return (
    <>
      <Combobox
        openOnFocus={true}
        aria-labelledby="combobox"
        onSelect={(item) => {
          setinputVal(item);
        }}
      >
        <ComboboxInput
          id="inputbox"
          name="infoVerified"
          type="text"
          value={inputVal}
          onChange={(e) => {
            setinputVal(e.target.value);
            fun(e);
          }}
          onFocus={(e) => fun(e)}
          list="d2"
        />
        <ComboboxPopover className="shadow-popup">
          <ComboboxList id="d2">
            <ComboboxOption value=" " />
            <ComboboxOption value="Verified" />
            <ComboboxOption value="Not Disclosed" />
          </ComboboxList>
        </ComboboxPopover>
      </Combobox>
    </>
  );
};

export default InfoVerifiedDropDown;